module.exports = __webpack_public_path__ + "img/coloso.7642eba4.jpg";